/*       */
import React, { PureComponent } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Typography } from '@mic3/platform-ui';

import { loadTasksAssigned } from 'store/actions/dashboard/dashboardActions';
import { bind } from 'app/utils/decorators/decoratorUtils';
import Widget from 'app/components/atoms/Widget/Widget';
import LinkList from 'app/containers/LandingPage/Widgets/LinkList';
import WidgetFooter from 'app/containers/LandingPage/Widgets/WidgetFooter';
import { get } from 'app/utils/lo/lo';
import { canViewWidget, widgetTypes } from '../dashboardUtils';

const StyledTypography = styled(Typography)`
    font-weight: 400 !important;
    font-style: 12px !important;
    line-height: 16px !important;
    letter-spacing: 0.4px !important;
    color: ${({ theme }) => theme.material.colors.text.secondary} !important;
`;

/**
 * Widget for displaying tasks assigned to the active user
 */
class TasksByCreatedDateWidget extends PureComponent {
    static propTypes = {
        loadTasksAssigned: PropTypes.func,
        isLoading: PropTypes.bool,
        records: PropTypes.array,
        user: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        const canView = canViewWidget(props?.item, props?.type);
        canView && props.loadTasksAssigned(props.user, { linkOnly: true });
    }

    @bind
    renderFooterContent() {
        return <WidgetFooter />;
    }
    @bind
    renderAdditionalInfo(props) {
        const createdDate = get(props, 'createdDate');
        let relativeTime;
        if (createdDate) {
            relativeTime = moment(createdDate).fromNow();
        }
        return <StyledTypography value={0}>{relativeTime || ''}</StyledTypography>;
    }
    @bind
    handleMenuItemClick(menu) {
        const { user, loadTasksAssigned, menuItemClick } = this.props;
        if (menu === 'Refresh') {
            loadTasksAssigned(user);
        } else {
            menuItemClick && menuItemClick(menu);
        }
    }

    render() {
        const { isLoading, records, item, permissions } = this.props;
        return (
            <Widget
                title={item?.widgetName || 'New Tasks'}
                subHeader='Created Date'
                content={
                    !isLoading && !records?.length ? (
                        'No Results'
                    ) : (
                        <LinkList list={records} type='task' renderAdditionalInfo={this.renderAdditionalInfo} />
                    )
                }
                loading={isLoading}
                footerContent={this.renderFooterContent}
                menuItemClick={this.handleMenuItemClick}
                permissions={permissions}
                item={item}
                type={widgetTypes.user}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.profile,
        isLoading: state.dashboard.tasksAssigned.isLoading,
        records: state.dashboard.tasksAssigned.records,
    };
};

export default connect(mapStateToProps, { loadTasksAssigned })(TasksByCreatedDateWidget);
